'use client';

import React from 'react';
import { MaturityData, MaturityKey } from '../data/initialData';

interface MaturityVisibilityToggleProps {
  maturities: MaturityData[];
  hiddenMaturities: Set<MaturityKey>;
  onToggle: (m: MaturityKey) => void;
}

export default function MaturityVisibilityToggle({
  maturities,
  hiddenMaturities,
  onToggle,
}: MaturityVisibilityToggleProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide whitespace-nowrap">
        Show on Curve
      </span>
      {maturities.map((m) => {
        const isVisible = !hiddenMaturities.has(m.maturity);
        return (
          <button
            key={m.maturity}
            type="button"
            onClick={() => onToggle(m.maturity)}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium transition-all duration-150 focus:outline-none ${
              isVisible
                ? 'bg-[#6C47FF]/8 border-[#6C47FF]/30 text-[#6C47FF]'
                : 'bg-gray-50 border-gray-200 text-gray-400'
            }`}
          >
            {/* Toggle pill */}
            <span
              className={`relative inline-flex w-7 h-4 rounded-full transition-colors duration-150 flex-shrink-0 ${
                isVisible ? 'bg-[#6C47FF]' : 'bg-gray-300'
              }`}
            >
              <span
                className={`absolute top-0.5 left-0.5 w-3 h-3 rounded-full bg-white shadow-sm transition-transform duration-150 ${
                  isVisible ? 'translate-x-3' : 'translate-x-0'
                }`}
              />
            </span>
            {m.maturity}
          </button>
        );
      })}
    </div>
  );
}
